import { convertProductsToAnalyticsEcommerceItems } from './analyticsProduct';
import { EcommerceEvent, pushGTMEcommerceEvent } from '@helpers/analyticsHelpers/pushGTMEvent';
import type { AxfoodCartProductViewModel } from '@occ/api-client';

const trackRemoveFromCart = (
  products: AxfoodCartProductViewModel[],
  listName: string,
  cartCode: string,
  isLoggedIn?: boolean
) => {
  const items = convertProductsToAnalyticsEcommerceItems(products, undefined, listName, isLoggedIn);

  pushGTMEcommerceEvent({
    event: EcommerceEvent.REMOVE_FROM_CART,
    ecommerce: {
      cart_id: cartCode,
      items,
    },
  });
};

export default trackRemoveFromCart;
